import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    messageGroupsUser: PropTypes.object.isRequired,
    messageGroupId: PropTypes.number.isRequired,
    currentUserId: PropTypes.number.isRequired,
    loadMessageListFromServer: PropTypes.func,
    loadRelatedUsersFromServer: PropTypes.func,
  },
  getInitialState() {
    return {
      messageGroupsUser: this.props.messageGroupsUser,
      messageGroupId: this.props.messageGroupId,
      currentUserId: this.props.currentUserId,
    };
  },
  handleRemoveUserFromMessageGroup: function() {
    $.ajax({
      url: "/api/message/remove_user_from_message_group",
      type: "POST",
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: {
        message_group_id: this.state.messageGroupId,
        user_id: this.state.messageGroupsUser.user.id,
      },
      cache: false,
      success: function(data) {
        if (data === "success") {
          this.setState({
            messageGroupsUser: [],
          });
          this.props.loadMessageListFromServer();
          this.props.loadRelatedUsersFromServer();
        }
      }.bind(this),
      error: function() {}.bind(this),
    });
  },
  onClick() {
    if (!confirm("本当に削除しますか？")) {
      return false;
    } else {
      this.handleRemoveUserFromMessageGroup();
    }
  },
  fullname_disp(user){
    if (user.is_fullname_hidden && user.is_verified_identity){
      return `@${user.tunagate_id}(本人確認済)`;
    }
    else if (!user.is_fullname_hidden && user.is_verified_identity){
      return  `${user.familyname} ${user.firstname}(本人確認済)`
    }
    else{
      return `${user.familyname} ${user.firstname}`
    }
  },
  render() {
    // var currentUserId = this.props.currentUserId;
    var userBox = "";
    var member_url =
      "/member/profile/" + this.state.messageGroupsUser.user.member_id;
    if (this.state.messageGroupsUser.user) {
      userBox = (
        <li>
          <label>
            <a href={member_url} target="_blank" rel="noreferrer">
              <img
                src={this.state.messageGroupsUser.user.avatar_thumb}
                style={{ width: "32px", height: "32px" }}
              />&nbsp; {this.fullname_disp(this.state.messageGroupsUser.user)}
              {this.state.messageGroupsUser.user.firstname}
            </a>
            &nbsp;&nbsp;
            <a onClick={this.onClick}>
              <i className="far fa-times-circle" />
            </a>
          </label>
        </li>
      );
    }
    return (
      <div>
        <ul className="nav modal-main-menu">{userBox}</ul>
      </div>
    );
  },
});
